import { useEffect, useState } from 'react';

/**
 * Client preference: show Search entry on Home + sidebar. Stored in localStorage.
 * Default true (search visible).
 */
const STORAGE_KEY = 'explore-show-search-in-nav-v1';

const listeners = new Set();

function emit() {
  listeners.forEach((fn) => fn());
}

/** @returns {boolean} */
export function loadShowSearchInNavigation() {
  if (typeof window === 'undefined') return true;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return true;
    return raw === '1' || raw === 'true';
  } catch {
    return true;
  }
}

/** @param {boolean} show */
export function setShowSearchInNavigation(show) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, show ? '1' : '0');
  } catch {
    /* quota / private mode */
  }
  emit();
}

/** @param {() => void} cb @returns {() => void} */
export function subscribeShowSearchInNavigation(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

/**
 * @returns {[boolean, (show: boolean) => void]}
 */
export function useShowSearchInNavigation() {
  const [show, setShow] = useState(() => loadShowSearchInNavigation());
  useEffect(() => subscribeShowSearchInNavigation(() => setShow(loadShowSearchInNavigation())), []);
  return [show, setShowSearchInNavigation];
}
